import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import TimePicker from 'src/components/Pickers/Time';
import DayPicker from 'src/components/Pickers/Day';
import NumberPicker from 'src/components/Pickers/Number';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    TimePicker: TimePicker,
    DayPicker: DayPicker,
    NumberPicker: NumberPicker,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    onSave: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      addOrRemoveEmail: false,
      myReport: {
        emails: _toConsumableArray(this.report.emails),
        schedule_hour: this.report.schedule_hour,
        schedule_interval: this.report.schedule_interval,
        schedule_day_of_month: this.report.schedule_day_of_month,
        schedule_day_of_week: this.report.schedule_day_of_week,
        name: this.report.name
      },
      emailShare: this.report.emails.length > 0 ? 'shared' : 'single',
      emailReportModified: false,
      emailInput: '',
      textValue: null,
      columns: [{
        name: 'email',
        align: 'left',
        label: this.$tc('general.e_mail', 1),
        field: 'email',
        sortable: false
      }, {
        name: 'confirmed',
        align: 'left',
        label: this.$t('general.status'),
        field: 'confirmed',
        sortable: false
      }, {
        name: 'delete',
        align: 'left',
        label: '',
        field: 'id',
        sortable: false
      }]
    };
  },
  computed: {
    validInputEmail: function validInputEmail() {
      var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(this.emailInput);
    },
    hasScheduleReport: function hasScheduleReport() {
      return this.me.account.hasFeatureAccess('scheduled_saved_reports');
    }
  },
  methods: {
    isValidEmail: function isValidEmail(value) {
      var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (value === null || value === '' || value.length < 3) {
        return true;
      }

      if (!regex.test(value)) {
        return this.$t('components.scheduleReportDialog.invalid_email_adress');
      }

      if (value !== '' && value !== null) {
        var exist = !!this.myReport.emails.find(function (el) {
          return el.email === value;
        });

        if (exist) {
          return this.$t('components.dialogs.email_already_exist');
        }
      }

      if (this.addOrRemoveEmail) {
        this.addOrRemoveEmail = false;
        return this.$t('components.scheduleReportDialog.press_add_or_enter');
      }

      return true;
    },
    addEmail: function addEmail(newEmail) {
      if (!this.isValidEmail(newEmail)) {
        this.emailInput = '';
        this.$q.notify({
          message: this.$t('components.scheduleReportDialog.invalid_email_adress'),
          type: 'negative'
        });
        return;
      }

      if (newEmail !== '' && newEmail !== null) {
        if (this.myReport.emails.length >= 10) {
          this.emailInput = '';
          this.$q.notify({
            message: this.$t('components.scheduleReportDialog.max_10_mails'),
            type: 'negative'
          });
          return;
        }

        var exist = !!this.myReport.emails.find(function (el) {
          return el.email === newEmail;
        });

        if (exist) {
          this.emailInput = '';
          this.$q.notify({
            message: this.$t('components.scheduleReportDialog.email_already_exist'),
            type: 'negative'
          });
          return;
        }

        this.myReport.emails.push({
          id: null,
          email: newEmail,
          confirmed: null
        });
        this.emailReportModified = true;
        this.emailInput = '';
      }
    },
    removeEmail: function removeEmail(email) {
      if (!this.me.account.hasFeatureAccess('scheduled_saved_reports')) {
        return;
      }

      this.myReport.emails = this.myReport.emails.filter(function (em) {
        return em.email !== email;
      });
      this.emailReportModified = true;
    },
    eventsMap: function eventsMap(itemEvents) {
      delete itemEvents.click;
      return itemEvents;
    },
    updateInterval: function updateInterval(interval) {
      if (this.me.account.hasFeatureAccess('scheduled_saved_reports') || interval === null) {
        this.myReport.schedule_interval = interval;
      }
    },
    save: function save() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.emailInput !== '')) {
                  _context.next = 4;
                  break;
                }

                _this.addOrRemoveEmail = true;

                _this.$refs.emailComp.validate();

                return _context.abrupt("return");

              case 4:
                _this.loading = true;
                _context.prev = 5;

                if (_this.emailShare !== 'shared') {
                  _this.myReport.emails = [];
                }

                _context.t0 = _this.onSave;

                if (!_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return _this.onSave(_this.myReport).then(function () {
                  _this.hide();

                  var newRecipientsCount = _this.myReport.emails.filter(function (obj) {
                    return obj.id === null;
                  }).length;

                  if (_this.emailReportModified && newRecipientsCount > 0) {
                    _this.openDialog('SharedEmailDialog', {
                      totalRecipientsCount: _this.myReport.emails.length,
                      newRecipientsCount: newRecipientsCount
                    }, _this);

                    _this.emailReportModified = false;
                  }
                });

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t1 = _context["catch"](5);
                console.error(_context.t1);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 13]]);
      }))();
    }
  }
};